// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchInventarioLenceria = async ({ limit = 50, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener el inventario de lencería');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el inventario de lencería:', error);
    throw error;
  }
};

export const fetchInventarioLenceriaById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener el elemento del inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el elemento del inventario:', error);
    throw error;
  }
};

export const createInventarioLenceria = async (inventarioData) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(inventarioData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el elemento del inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el elemento del inventario:', error);
    throw error;
  }
};

export const updateInventarioLenceria = async (id, inventarioData) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: inventarioData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el elemento del inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el elemento del inventario:', error);
    throw error;
  }
};

export const deleteInventarioLenceria = async (id) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el elemento del inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el elemento del inventario:', error);
    throw error;
  }
};

export const fetchInventarioLenceriaByPropiedad = async (propiedadId, { limit = 50, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        limit, 
        offset, 
        query: {
          ...query,
          'propiedad.id': propiedadId
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener el inventario de la propiedad');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el inventario de la propiedad:', error);
    throw error;
  }
};

export const bulkUpdateInventarioLenceria = async (updates) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/bulk-update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar elementos del inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar elementos del inventario:', error);
    throw error;
  }
};

export const importInventarioLenceria = async (file, propiedadId) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('propiedadId', propiedadId);

    const response = await fetch(`${API_URL}/inventario-lenceria/import`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Error al importar el inventario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al importar el inventario:', error);
    throw error;
  }
};

export const exportInventarioLenceria = async (propiedadId, filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        propiedadId,
        filters 
      }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar el inventario');
    }

    // Descargar el archivo
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `inventario-lenceria-${propiedadId}-${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return { success: true };
  } catch (error) {
    console.error('Error al exportar el inventario:', error);
    throw error;
  }
};
